import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  FormFeedback,
  Button,
  FormGroup,
  FormText
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchCustomerRequest, updateCustomerRequest } from "../../store/customers/actions";
import IMPartnerSelector from "../../components/ui/IMPartnerSelector";
import IMMasterDropdown from "../../components/ui/IMMasterDropdown";
import IMMasterSubCategoryMultiSelect from "../../components/ui/IMMasterSubCategoryMultiSelect";
import IMLocation from "../../components/ui/IMLocation";
import { useNavigate, useParams } from "react-router-dom";
import IMPhoto from "../../components/ui/IMPhoto";

const UpdateCustomer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { customerId } = useParams();
  const { selectedCustomer, loading, error } = useSelector((state) => state.customers);
  const selectedPartner = useSelector(state => state.partners.selectedPartner);

  useEffect(() => {
    if (customerId) {
      console.log('customerId',customerId, selectedPartner.id)
      dispatch(fetchCustomerRequest(selectedPartner.id, customerId));
    }
  }, [dispatch, customerId]);

  const validationSchema = Yup.object({
    name: Yup.string().required("Please Enter Customer Name"),
    email: Yup.string().email("Invalid email format").required("Please Enter Email"),
    status: Yup.string().required("Please Select Status"),
    services: Yup.array().min(1, "Select at least one service").required("Please Select Services"),
    location: Yup.object().shape({
      label: Yup.string().required("Please select a location")
    }).nullable().required("Please select a location"),
  });

  const handleSubmit = (values) => {
    const customerData = {
      ...values,
      id: customerId,
      vendor: selectedPartner,
      vendorID: selectedPartner.id,
    };
    dispatch(updateCustomerRequest(customerData, navigate));
  };

  const initialValues = {
    name: selectedCustomer ? selectedCustomer.name : "",
    email: selectedCustomer ? selectedCustomer.email : "",
    status: selectedCustomer ? selectedCustomer.status : "",
    services: selectedCustomer ? selectedCustomer.services : [],
    location: selectedCustomer ? selectedCustomer.location : null,
    photo: selectedCustomer ? selectedCustomer.photo : "",
  };

  return (
    <div className="page-content">
      <Breadcrumbs title="Customers" breadcrumbItem="Update Customer" />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              {error && <div className="alert alert-danger">{error}</div>}
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {formik => (
                  <Form>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label htmlFor="name">Customer Name</Label>
                          <Input
                            id="name"
                            name="name"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                            invalid={
                              formik.touched.name && !!formik.errors.name
                            }
                          />
                          <FormFeedback>{formik.errors.name}</FormFeedback>
                          <FormText color="muted">
                            Enter the name of the customer.
                          </FormText>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label htmlFor="email">Email</Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            invalid={
                              formik.touched.email && !!formik.errors.email
                            }
                          />
                          <FormFeedback>{formik.errors.email}</FormFeedback>
                          <FormText color="muted">
                            Enter the email address of the customer.
                          </FormText>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <IMMasterDropdown
                            collectionName="status"
                            selectedValue={formik.values.status}
                            onChange={option =>
                              formik.setFieldValue("status", option.label)
                            }
                            label="Status"
                          />
                          <FormFeedback>{formik.errors.status}</FormFeedback>
                          <FormText color="muted">
                            Select the status of the customer.
                          </FormText>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <IMMasterSubCategoryMultiSelect
                            collectionName="poNq3omWLHyHDtIlnr7o" // o el nombre de la colección relevante
                            selectedValues={formik.values.services}
                            onChange={value =>
                              formik.setFieldValue("services", value)
                            }
                            label="Subcategories"
                          />
                          <FormFeedback>{formik.errors.services}</FormFeedback>
                          <FormText color="muted">
                            Select one or more services for the customer.
                          </FormText>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <IMLocation
                          label="Location"
                          selectedLocation={formik.values.location}
                          onLocationSelect={location =>
                            formik.setFieldValue("location", location)
                          }
                          formik={formik}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <IMPhoto
                          currentPhoto={formik.values.photo}
                          onUpload={url => formik.setFieldValue("photo", url)}
                          fieldName="photo"
                          formik={formik}
                        />
                      </Col>
                    </Row>
                    <Button type="submit" color="primary" disabled={loading}>
                      {loading ? "Loading..." : "Update"}
                    </Button>
                    <Button
                      type="button"
                      color="secondary"
                      className="ml-2"
                      onClick={() => window.history.back()}
                    >
                      Back to Customers List
                    </Button>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
};

export default UpdateCustomer;